<template src="./ModalWarehouseListComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, computed} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {AppConstant} from "@/supports/app.constant";
import {useAccountStore} from "@/stores/account.js";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
import {useWarehouseStore} from "@/stores/warehouse.js";
import {forEach} from "vuedraggable/dist/vuedraggable.common.js";
export default {
  name: 'ModalWarehouseListComponent',
  components: {
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModalWarehouse: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    typeSelectItem: {
      type: String,
      required: false,
      default: () => 'multiple'
    },
    listWarehousesSelected: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['showModalWarehouse', 'searchWarehouse', 'listWarehousesSelectedCurrent'],
  setup(props, { emit }) {
    const dataHeaderTable = ref({
      warehouse_name: {
        label: 'Tên kho hàng',
        order: 1,
        width: '15%',
      },
      warehouse_code: {
        label: 'Mã kho hàng',
        order: 2,
        width: '10%',
      },
      warehouse_phone: {
        label: 'Số điện thoại',
        order: 3,
        width: '10%',
      },
      warehouse_addr: {
        label: 'Địa chỉ',
        order: 4,
        width: '10%',
      },
      quantityTypeInWarehouse: {
        label: 'Tổng số lượng mỗi loại',
        order: 5,
        width: '10%',
      },
      quantityInWarehouse: {
        label: 'Tổng số lượng trong kho',
        order: 6,
        width: '5%',
      },
    })
    const dataSearch = ref({
      warehouse_name: {
        id: 'warehouse_name',
        label: 'Tên kho hàng',
        placeholder: 'Tên kho hàng',
        value: '',
        required: false
      },
      warehouse_code: {
        id: 'warehouse_code',
        label: 'Mã kho hàng',
        placeholder: 'Mã kho hàng',
        value: '',
        required: false
      },
      warehouse_phone: {
        id: 'warehouse_phone',
        label: 'Số điện thoại',
        placeholder: 'Số điện thoại',
        value: '',
        required: false
      },
      warehouse_addr: {
        id: 'warehouse_addr',
        label: 'Địa chỉ',
        placeholder: 'Địa chỉ',
        value: '',
        required: false
      },
    })
    const listsWarehouseCurrent = ref([])
    const listChecked = ref({})
    const listWarehousesSelectedCurrent = ref([])
    const labelButtonSearch = ref('Tìm kiếm')
    const urlOrigin = ref('/arrival/list/')
    const clickShowModal = ref(false)
    const warehouseStore = useWarehouseStore()
    const accountStore = useAccountStore()

    // bind list warehouse when call api get list
    watch(() => warehouseStore.warehouses, (newListWarehouse) => {
      listsWarehouseCurrent.value = newListWarehouse
    });

    // bind list warehouse selected when show modal
    watch(() => props.listWarehousesSelected, (newListWarehouseSelected) => {
      listChecked.value = [];
      listWarehousesSelectedCurrent.value = [];
      newListWarehouseSelected.forEach((item) => {
        listChecked.value[item.id] = true
        listWarehousesSelectedCurrent.value.push(item.id)
      })
    });

    // bind event click show modal to call api get list warehouse
    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      clickShowModal.value = eventClickShowModal

      if(clickShowModal.value && (warehouseStore.warehouses.length === 0 || (warehouseStore.warehouses.length > 0 && warehouseStore.lastPage !== 1)) ) {
        getListWarehouse(1)
        emit('showModalWarehouse', true)
      }
      if(warehouseStore.warehouses.length > 0 && warehouseStore.lastPage === 1) {
        listChecked.value = [];
        listWarehousesSelectedCurrent.value.forEach((id) => {
          listChecked.value[id] = true
        })
        emit('showModalWarehouse', true)
      }
    })

    // call api get list warehouse
    async function getListWarehouse(page, event) {
      const params = {
        id: accountStore.account.company.id,
        warehouse_name: dataSearch.value.warehouse_name.value,
        warehouse_code: dataSearch.value.warehouse_code.value,
        warehouse_phone: dataSearch.value.warehouse_phone.value,
        warehouse_addr: dataSearch.value.warehouse_addr.value,
        page: page,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/warehouse/warehouse-list';
      await warehouseStore.getListWarehousesWithLimit(url, params);
      if(event === 'search') {
        setTimeout(function () {
          emit('searchWarehouse', false)
        }, 500)
      }
    }

    // search warehouse
    function searchWarehouses() {
      emit('searchWarehouse', true)
      getListWarehouse(1, 'search');
    }

    // event change input search
    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    // listen change by paginate
    const paginate = computed(() => {
      return warehouseStore.paginate;
    });
    // emit page from paginate component
    function emitPage(page) {
      getListWarehouse(page);
    }
    // submit modal to get warehouse selected
    function applyWarehouseSelected() {
      const listWarehouse = [];
      listWarehousesSelectedCurrent.value.forEach((id) => {
        const warehouseCheck = listsWarehouseCurrent.value.find((item) => item.id === id);
        if(warehouseCheck) {
          listWarehouse.push(warehouseCheck);
        }
      })

      emit('listWarehousesSelectedCurrent', listWarehouse)
      emit('showModalWarehouse', false)
    }

    // event change by checkbox
    function onChangeSelectWarehouse(value, warehouseId) {
      listChecked.value[warehouseId] = value
      if(props.typeSelectItem === 'single') {
        listChecked.value.forEach((itemCheck, key) => {
          if(key !== warehouseId) {
            delete listChecked.value[key]
          }
        })
        listWarehousesSelectedCurrent.value = [];
        listWarehousesSelectedCurrent.value.push(warehouseId)
      }
      if(props.typeSelectItem === 'multiple') {
        listsWarehouseCurrent.value.forEach((warehouse) => {
          if(value && listWarehousesSelectedCurrent.value.indexOf(warehouse.id) === -1 && parseInt(warehouseId) === parseInt(warehouse.id)) {
            listWarehousesSelectedCurrent.value.push(warehouse.id)
          }else if (!value && listWarehousesSelectedCurrent.value.indexOf(warehouse.id) !== -1 && parseInt(warehouseId) === parseInt(warehouse.id)) {
            listWarehousesSelectedCurrent.value.splice(listWarehousesSelectedCurrent.value.indexOf(warehouse.id), 1);
          }
        })
      }
    }

    return {
      dataHeaderTable,
      listsWarehouseCurrent,
      dataSearch,
      labelButtonSearch,
      paginate,
      urlOrigin,
      listChecked,
      searchWarehouses,
      onChange,
      onChangeSelectWarehouse,
      emitPage,
      applyWarehouseSelected,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modaldeliverywarehouse {
  .modal-content {
    background: #ffffff;
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
